import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

type CookieConsentValue = 'accepted' | 'declined';

const STORAGE_KEY = 'cookie_consent_v1';

function readConsent(): CookieConsentValue | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { value?: CookieConsentValue };
    if (parsed?.value === 'accepted' || parsed?.value === 'declined') return parsed.value;
    return null;
  } catch {
    return null;
  }
}

function writeConsent(value: CookieConsentValue) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      value,
      timestamp: new Date().toISOString(),
    })
  );
}

const CookieConsentBanner: React.FC = () => {
  const initial = useMemo(() => readConsent(), []);
  const [consent, setConsent] = useState<CookieConsentValue | null>(initial);

  useEffect(() => {
    setConsent(readConsent());
  }, []);

  if (consent) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[1100] border-t border-border bg-card/95 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 py-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="text-sm text-foreground">
          Folosim cookie-uri esențiale pentru funcționarea site-ului. Poți alege să accepți sau să refuzi cookie-uri
          neesențiale.{' '}
          <Link className="underline text-muted-foreground hover:text-foreground" to="/legal/politica-de-cookies">
            Află mai multe
          </Link>
          .
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="px-3 py-2 rounded-md border border-border text-sm hover:bg-muted"
            onClick={() => {
              writeConsent('declined');
              setConsent('declined');
            }}
          >
            Refuz
          </button>
          <button
            type="button"
            className="px-3 py-2 rounded-md bg-primary text-primary-foreground text-sm hover:bg-primary/90"
            onClick={() => {
              writeConsent('accepted');
              setConsent('accepted');
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;

